var BaseView = require('../../../components/accordion-list/content');

module.exports = BaseView.extend({
  initialize: function (options) {
    this.albumId = options.albumId;
    BaseView.prototype.initialize.call(this);
  },

  loadData: function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    this.imagesFactory.getFacebookPhotos(this.getParams(), this.onMoreData);
  },

  getParams: function () {
    return {
      albums: [ { id: this.albumId, after: this.after } ],
      fb_token: this.tool.facebookToken || FB.getAccessToken()
    };
  },

  onMoreData: function (status, imagesData, data) {
    var callback = _.bind(this.tool.callbackImages, this.tool);
    var values = this.extractData(imagesData, data[this.albumId]['data']);

    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    this.after = data[this.albumId]['paging']['cursors']['after'];

    this.tool.addThumbItem(this.$el, values, callback);
    this.scrollRefresh();

    if (!data[this.albumId]['paging']['next']) this.end();
    else this.repeat();
  },

  getScrollHeight: function ($target) {
    var marginTop = 65;
    return $target.closest('.add').height() - marginTop;
  },

  extractData: function (imagesData, data) {
    return _.map(data, function (item, index) {
      return {
        id: 'photo-fb-' + item['object_id'],
        src: item['src'],
        data: imagesData[item.src_big],
        width: 125,
        height: 84
      };
    });
  }
});
